
/**
 * Service for direct Meta API calls without using Supabase Edge Functions
 * This file re-exports functionality from other modules for backward compatibility
 */

// Import all dependencies first
import { META_APP_ID as IMPORTED_META_APP_ID, API_VERSION as IMPORTED_API_VERSION } from './constants';
import { validateToken as importedValidateToken, initiateOAuthFlow } from './auth';
import { getAccounts as importedGetAccounts } from './accounts';
import { getCampaigns as importedGetCampaigns, getCampaignInsights as importedGetCampaignInsights } from './campaigns';
import { getInsightsDatePresets as importedGetInsightsDatePresets } from './datePresets';

// Re-export types
export type { 
  MetaAccount,
  MetaCampaign,
  InsightsDatePreset,
  CampaignInsightsFields
} from './types';

// Re-export constants and functions
export const META_APP_ID = IMPORTED_META_APP_ID;
export const API_VERSION = IMPORTED_API_VERSION;
export const validateToken = importedValidateToken;
export const getAccounts = importedGetAccounts;
export const getCampaigns = importedGetCampaigns;
export const getCampaignInsights = importedGetCampaignInsights;
export const getInsightsDatePresets = importedGetInsightsDatePresets;

// Create a single MetaApiService class for backward compatibility
export class MetaApiService {
  static META_APP_ID = IMPORTED_META_APP_ID;
  static API_VERSION = IMPORTED_API_VERSION;
  
  // Re-export functions as static methods
  static validateToken = importedValidateToken;
  static getAccounts = importedGetAccounts;
  static getCampaigns = importedGetCampaigns;
  static getCampaignInsights = importedGetCampaignInsights;
  static getInsightsDatePresets = importedGetInsightsDatePresets;
}
